<template>
  <ItemTable
    ref="itemTable"
    v-bind="itemTableProps"
    :disableBulkAction="tableImportConditions.disableImportUsers"
    :disableSelectAllItems="tableImportConditions.disableSelectAllUsers"
    :disableSelectItems="tableImportConditions.disableSelectUsers"
  />
</template>
<script>
import { ItemTypeConsts } from 'client/util/Constants';
import ItemTable from 'client/components/ItemTable/ItemTable.vue';

export default {
  name: 'ImportUsersSelection',

  components: {
    ItemTable,
  },

  props: {
    tableImportConditions: {
      default: () => ({}),
      type: Object,
    },
  },

  data() {
    return {
      itemTableProps: {
        columns: [
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'firstname',
              type: 'text',
            },
            headingText: 'First Name',
            sortBy: 'firstname',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'lastname',
              type: 'text',
            },
            headingText: 'Last Name',
            sortBy: 'lastname',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'email',
              validation: 'required|email',
              type: 'email',
            },
            headingText: 'Email',
            sortBy: 'email',
          },
          {
            bodyComponent: 'EditableInput',
            bodyComponentProps: {
              field: 'username',
              validation: 'required|regex:^[A-Za-z_][a-zA-Z0-9_.-]*$|max:30',
              type: 'text',
            },
            headingText: 'Username',
            sortBy: 'username',
          },
        ],
        hasSelectColumn: true,
        inPanel: false,
        itemType: ItemTypeConsts.importUsers,
        legacyRowStyles: false,
        showActionBar: false,
        showSearchForm: false,
        useLargeTableCells: true,
      },
    };
  },
};
</script>
